import { ofType } from "redux-observable";
import { take } from "rxjs/operators";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
import { checkTutorialConstructConstructionProgress } from "../checks/checkTutorialConstructConstructionProgress";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { pathTutorialUpdateViewport } from "../path/pathTutorialUpdateViewport";
export var epicTutorialConstructConstructionProgress = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.FinishPlacement), take(1), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkTutorialNextStepConfigExists,
            checkTutorialConstructConstructionProgress,
        ])(pathTutorialUpdateViewport),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialConstructConstructionProgress.ts
// module id = 2464
// module chunks = 3